// extracted by mini-css-extract-plugin
module.exports = {"UnorderedStyle":"OrderSummary_UnorderedStyle__2TeTz","IngredientStyle":"OrderSummary_IngredientStyle__aGact","Price":"OrderSummary_Price__31CfO"};